module.exports = __webpack_public_path__ + "img/42fa43a704d04302bab5a10b36572502.png";